var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"balance-statistic-item"},[_c('div',{staticClass:"balance-statistic-item__image"},[_c('span',{class:`icon-coin-${_vm.index}`})]),_c('div',{staticClass:"balance-statistic-item__info"},[_c('h5',[_vm._v(_vm._s(_vm.formattedBalance))]),_c('p',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }